module.exports = __webpack_public_path__ + "img/ptzc02.95406911.png";